import { render, staticRenderFns } from "./OrgChartNode.vue?vue&type=template&id=8549bb8e&scoped=true&"
import script from "./OrgChartNode.vue?vue&type=script&lang=js&"
export * from "./OrgChartNode.vue?vue&type=script&lang=js&"
import style0 from "./OrgChartNode.vue?vue&type=style&index=0&id=8549bb8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8549bb8e",
  null
  
)

export default component.exports